import { useQueryClient, type QueryKey } from '@tanstack/vue-query';

/**
 * Invalidation over one key factory, a no-op until the id is there — the
 * counterpart of the gate `useScopedQuery` puts on the observer.
 */
export function useInvalidateScoped(keyFor: (id: string) => QueryKey) {
  const queryClient = useQueryClient();

  return async (id: string | null | undefined) => {
    if (!id) return;
    await queryClient.invalidateQueries({ queryKey: keyFor(id) });
  };
}
